module.exports = __webpack_public_path__ + "img/options.8638f735.svg";